import React from "react";
import { TextField } from "@mui/material";
import { IOption, IURLLoaderConfig } from "../../constants/model-interfaces";
import { IError } from "../../constants/common-interface";

const ModalSearchControl = (props: IProps) => {
    const match = props.options && props.options.find((o) => o.value === props.value);
    return (
        <div
            className={props.wrapperClassName + " meta-form-control-modal-search"}
            onClick={() => {
                const options = props.context.getFieldOptions(props.section, props.field);
                props.context.emit("open_modalsearch", {
                    label: props.label,
                    value: props.value,
                    options: options,
                    section: props.section,
                    config: props.config,
                    field: props.field,
                    valueCallback: props.handleChange
                });
            }}
        >
            <TextField
                disabled
                error={props.error.hasError ? true : undefined}
                label={props.label}
                value={match ? match.label : ""}
                variant={props.variant}
                helperText={props.error.errorMsg}
                fullWidth
            />
        </div>
    );
};

interface IProps {
    config: IURLLoaderConfig | undefined;
    label: string;
    value: string | number | boolean | undefined;
    context: any;
    options: Array<IOption>;
    variant: any;
    error: IError;
    field: string;
    section: string;
    handleChange: Function;
    wrapperClassName: string;
}

export default ModalSearchControl;
